<script>
    import ImageResponsive from "@/components/ImageResponsive";

    export default {
        name: "LookbookImage",
        components: { ImageResponsive },
        props: {
            name: String,
            index: [String, Number],
            isAnimated: Boolean,
            direction: {
                type: String,
                validator: (v) => ["left", "right"].includes(v),
            },
        },
        computed: {
            source() {
                const path = `/static/xd-design/lookbook/products/${this.name}/`;
                return {
                    mobile: `${path}${this.index}--mobile.jpg?v=090922`,
                    desktop: `${path}${this.index}.jpg?v=090922`,
                    desktopX2: `${path}${this.index}x2.jpg?v=090922`,
                };
            },
        },
    };
</script>

<template>
    <div
        class="lookbook-image"
        :class="{ 'is-animated': isAnimated, [`is-${direction}`]: direction }"
    >
        <image-responsive
            :mobile="source.mobile"
            :desktop="source.desktop"
            :desktop-x2="source.desktopX2"
            :alt="name"
        ></image-responsive>
    </div>
</template>

<style lang="scss">
    .lookbook-image {
        @include center-absolute(0);
        overflow: hidden;
        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transform: scale(1);
            @include clip-path(polygon(0 0, 100% 0, 100% 100%, 0% 100%));
            transition: all 1.3s cubic-bezier(0, 0, 0.13, 1);
        }
        &.is-left {
            img {
                @include clip-path(polygon(0 0, 100% 0, 100% 100%, 0% 100%));
            }
        }
        &.is-right {
            img {
                @include clip-path(polygon(0 0, 100% 0, 100% 100%, 0% 100%));
            }
        }
        &.is-animated {
            img {
                transform: scale(1.9);
                @include clip-path(polygon(0 100%, 100% 100%, 100% 100%, 0 100%));
            }
            &.is-left {
                img {
                    @include clip-path(polygon(0 0, 0 0, 0 0, 0 0));
                }
            }
            &.is-right {
                img {
                    @include clip-path(polygon(100% 0, 100% 0, 100% 0, 100% 0));
                }
            }
        }
        &[data-name="image-1"] {
            img {
                transition-delay: 0.25s;
            }
        }
        &[data-name="image-2"] {
            img {
                transition-delay: 0.4s;
            }
        }
    }
</style>
